// extracted by mini-css-extract-plugin
module.exports = {"Container":"EmissionsDoughnutCentralSummary_Container__2Q9gV","Amount":"EmissionsDoughnutCentralSummary_Amount__2DDmv","CO2":"EmissionsDoughnutCentralSummary_CO2__aED1F"};